import * as React from "react";
import { IconProps } from "../types";

const CopiesPlusIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M7.75 15.25H3.75C3.198 15.25 2.75 14.802 2.75 14.25V8.75C2.75 8.198 3.198 7.75 3.75 7.75H14.25C14.802 7.75 15.25 8.198 15.25 8.75V11.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 5.75C3.25 5.198 3.698 4.75 4.25 4.75H13.75C14.302 4.75 14.75 5.198 14.75 5.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 2.75C3.75 2.198 4.198 1.75 4.75 1.75H13.25C13.802 1.75 14.25 2.198 14.25 2.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.75 12.25V17.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.25 14.75H10.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default CopiesPlusIcon;
